<!-- 每日一练 -->
<template>
<van-popup v-model="show" class="mryl-popup list-popup" position="right" :overlay-style="{background: '#fff'}">
    <div class="list-nav">
        <van-icon name="arrow-left" @click="handleClose" />
        <div class="nav-name">每日一练</div>
    </div>
    <!-- <el-scrollbar class="subject-item-box">
        <div class="subject-item" @click="handleChangeActiveSubject(item)" v-for="(item) in tabList" :key="item.code" :class="{active: item.code === activeSubject.code}">{{ item.name }}</div>
    </el-scrollbar> -->
    <div class="subject-box">
        <div class="subject-name">{{ activeSubject.name }}</div>
        <div class="handle" @click="handleOpenChangeSubject">
            <img class="handle-icon" :src="require('@/common/images/mSpecialTopic/change_icon.png')" />
            <div class="handle-label">切换科目</div>
        </div>
    </div>
    <img class="mryl-banner" :src="require('@/common/images/mSpecialTopic/mryl_banner.png')" />
    <div class="practice-list">
        <div class="practice-item" v-for="(item, index) in activeSubject.list" :key="index">
            <div class="name">{{ item.subject }}</div>
            <div class="item-handle">
                <div class="lock-btn" v-if="!activeSubject.isjoin" @click="handleBuy">
                    <img class="lock-icon" :src="require('@/common/images/mSpecialTopic/lock_icon.png')" />
                    <div class="label">购买解锁</div>
                </div>
                <div v-else>
                    <img class="do-exam-icon" v-if="item.status === 0" @click="handleUpdateTopicUserExamDayTrainStartExam(item)" :src="require('@/common/images/mSpecialTopic/do_exam_icon.png')" />
                    <div class="again-exam" v-if="item.status === 10" @click="handleUpdateTopicUserExamDayTrainStartExam(item)">重做</div>
                    <div class="continue-exam" v-if="item.status === 1" @click="handleContinueExam(item)">继续</div>
                </div>
            </div>
        </div>
    </div>
    <ChangeSubject ref="changeSubject" @handleSubjectChange="handleSubjectChange"></ChangeSubject>
</van-popup>
</template>

<script>
import specialTopic from '@/common/js/specialTopic.json'
import {mapGetters, mapActions} from 'vuex'
import {getTopicUserExamDayTrainData, updateTopicUserExamDayTrainStartExam} from '@/api/specialTopic.js'
import ChangeSubject from '../component/changeSubject.vue'
export default {
    data() {
        return {
            show: false,
            activeSubject: {
                code: this.$route.query.subjectcode ? this.$route.query.subjectcode : '',
                list: []
            },
            tabList: []
        }
    },
    props: {
        subjectList: {
            type: Array,
            required: true,
            default: () => {
                return specialTopic.subject[this.$route.params.examcode]
            }
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    components: {
        ChangeSubject
    },
    methods: {
        handleOpen() {
            this.show = true
            this.handleInit()
        },
        handleClose() {
            this.show = false
        },
        handleChangeActiveSubject(item) {
            if (item.code !== this.activeSubject.code) {
                this.activeSubject = JSON.parse(JSON.stringify(item))
                if (!this.activeSubject.init) {
                    if (this.activeSubject.isjoin) {
                        this.handleGetTopicUserExamDayTrainData()
                    } else {
                        this.activeSubject.list = [
                            {subject: this.activeSubject.name, code: this.activeSubject.code, status: 0}
                        ]
                    }
                }
            }
        },
        handleOpenChangeSubject() {
            this.$refs.changeSubject.handleOpen(this.$route.params.examcode, this.activeSubject.code)
        },
        handleSubjectChange(subjectcode) {
            if (subjectcode !== this.activeSubject.code) {
                this.tabList.some(item => {
                    if (item.code === subjectcode) {
                        this.handleChangeActiveSubject(item)
                        return true
                    }
                })
            }
        },
        handleInit() {
            if (!this.activeSubject.init) {
                if (this.user.loginToken) {
                    this.handleGetTopicUserExamDayTrainData()
                } else {
                    this.activeSubject.list = [
                        {subject: this.activeSubject.name, code: this.activeSubject.code, status: 0}
                    ]
                }
            }
        },
        handleGetTopicUserExamDayTrainData() {
            this.setLoading(true)
            getTopicUserExamDayTrainData({
                data: {
                    examcode: this.$route.params.examcode,
                    subjectcode: this.activeSubject.code,
                    traindate: ''
                },
                success: data => {
                    this.setLoading(false)
                    this.activeSubject.list = data.data
                    this.activeSubject.init = true
                    this.tabList.some(item => {
                        if (item.code === this.activeSubject.code) {
                            item.list = data.data
                            item.init = true
                            return true
                        }
                    })
                },
                error: error => {
                    this.setLoading(false)
                    if ((error.code === '301' && error.msg === '用户信息错误') || (error.code === '401' && error.msg === '会员没有登录！')) {
                        this.handleExitLogin()
                        this.activeSubject.list = [
                            {subject: this.activeSubject.name, code: this.activeSubject.code, status: 0}
                        ]
                    } else {
                        this.$toast.fail(error.msg)
                    }
                }
            })
        },
        handleUpdateTopicUserExamDayTrainStartExam(item) {
            this.setLoading(true)
            updateTopicUserExamDayTrainStartExam({
                data: {
                    code: item.code,
                    examcode: this.$route.params.examcode,
                    subjectcode: this.activeSubject.code,
                    traindate: ''
                },
                success: data => {
                    this.setLoading(false)
                    item.status = 1
                    item.recentexamcode = data.data
                    sessionStorage.setItem('specialTopicMrylCode', item.code)
                    this.$router.push({
                        name: 'MSpecialTopicExam',
                        params: {
                            examsource: 1,
                            examcode: this.$route.params.examcode
                        },
                        query: {
                            examid: data.data,
                            subjectcode: this.activeSubject.code
                        }
                    })
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleContinueExam(item) {
            sessionStorage.setItem('specialTopicMrylCode', item.code)
            this.$router.push({
                name: 'MSpecialTopicExam',
                params: {
                    examsource: 1,
                    examcode: this.$route.params.examcode
                },
                query: {
                    examid: item.recentexamcode,
                    subjectcode: this.activeSubject.code,
                    ischeck: item.status === 10 ? 1 : 0
                }
            })
        },
        // 退出登录
        handleExitLogin() {
            window.sessionStorage.clear()
            let user = {
                innerid: '',
                loginToken: '',
                loginname: '',
                logourl: '',
                mobile: '',
                name: '',
                nickname: '',
                isLogin: false
            }
            this.setUser(user)
            this._delCookie('token')
        },
        _setCookie(key, value, expiredays) {
            let exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            document.cookie = key + '=' + value
            + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
            + ';path=/'
            + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
        },
        _delCookie(key) {
            this._setCookie(key, "", -1);
        },
        handleBuy() {
            this.$emit('handleBuyTopic', this.activeSubject.code)
        },
        ...mapActions([
            'setLoading',
            'setUser'
        ])
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    watch: {
        subjectList: {
            handler(newV) {
                if (newV && newV.length) {
                    if (this.activeSubject.code) {
                        let flag = false
                        newV.some(item => {
                            if (item.code === this.activeSubject.code) {
                                this.activeSubject = JSON.parse(JSON.stringify(item))
                                flag = true
                                return true
                            }
                        })
                        if (!flag) {
                            this.activeSubject = JSON.parse(JSON.stringify(newV[0]))
                        }
                    } else {
                        this.activeSubject = JSON.parse(JSON.stringify(newV[0]))
                    }
                    this.tabList = JSON.parse(JSON.stringify(newV))
                }
            },
            deep: true
        }
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
.mryl-popup {
    width: 100vw;
    height: 100vh;
    background: #F8F8F8;
    overflow: hidden;
    .list-nav {
        background: #fff;
        height: 0.88rem;
        padding: 0 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 10;
        box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
        .van-icon {
            font-size: 0.4rem;
            position: relative;
            z-index: 12;
        }
        .nav-name {
            position: absolute;
            z-index: 11;
            width: 100%;
            left: 0;
            line-height: 0.88rem;
            text-align: center;
            font-size: 0.34rem;
            color: #333333;
            font-weight: bold;
            box-sizing: border-box;
        }
    }
    .subject-item-box {
        height: 0.8rem;
        .el-scrollbar__view {
            display: flex;
            height: 0.8rem;
            .subject-item {
                padding: 0 0.35rem;
                line-height: 0.8rem;
                font-size: 0.3rem;
                color: #333333;
                white-space: nowrap;
                background: #fff;
                &.active {
                    color: #1D60AD;
                    background: rgba(29,96,173,0.1);
                    font-weight: bold;
                }
            }
        }
    }
    .subject-box {
        height: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.28rem;
        box-sizing: border-box;
        background: #fff;
        .subject-name {
            font-size: 0.3rem;
            color: #333333;
            font-weight: bold;
        }
        .handle {
            display: flex;
            align-items: center;
            .handle-icon {
                width: 0.28rem;
                height: 0.28rem;
                margin-right: 0.08rem;
            }
            .handle-label {
                font-size: 0.26rem;
                color: #666666;
            }
        }
    }
    .mryl-banner {
        width: 100%;
        height: 2.4rem;
    }
    .practice-list {
        .practice-item {
            padding: 0.52rem 0.28rem 0.52rem 0.32rem;
            display: flex;
            align-items: center;
            background: #fff;
            .name {
                font-size: 0.3rem;
                color: #333333;
                flex: 1;
                width: 0;
                font-weight: bold;
                margin-right: 0.64rem;
                line-height: 0.42rem;
            }
            .item-handle {
                .lock-btn {
                    .lock-icon {
                        width: 0.38rem;
                        height: 0.38rem;
                        margin: 0 auto 0.04rem;
                    }
                    .label {
                        font-size: 0.22rem;
                        color: #999999;
                        line-height: 0.3rem;
                    }
                }
                .do-exam-icon {
                    width: 0.46rem;
                    height: 0.46rem;
                }
                .again-exam {
                    width: 0.98rem;
                    height: 0.54rem;
                    background: #1D60AD;
                    border-radius: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 0.24rem;
                }
                .continue-exam {
                    width: 0.98rem;
                    height: 0.54rem;
                    background: #fff;
                    border: 0.02rem solid #1D60AD;
                    box-sizing: border-box;
                    border-radius: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #1D60AD;
                    font-size: 0.24rem;
                }
            }
        }
    }
}
</style>